import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/smtp/')({
  beforeLoad: () => {
    throw redirect({ to: '/smtp' })
  },
})
